import React from "react";
import { TIERS, BADGES } from "@/lib/tiers";
import { Crown, Flame, Sparkles, Trophy, Medal, Skull } from "lucide-react";

function roleIcon(role) {
  if (role === "god_tier_supporter") return <Sparkles className="w-3 h-3" />;
  if (role === "hardcore_cultist") return <Flame className="w-3 h-3" />;
  if (role === "elite_cultist") return <Crown className="w-3 h-3" />;
  // Founder — crown icon (👑 emoji rendered as Lucide icon for crisp dark-mode)
  if (role === "admin") return <Crown className="w-3 h-3" />;
  return null;
}

function TopBadgeIcon({ kind }) {
  if (kind === "cult_master") return <Skull className="w-3 h-3" />;
  if (kind === "top_1_supporter") return <Trophy className="w-3 h-3" />;
  if (kind === "top_2_supporter") return <Medal className="w-3 h-3" />;
  if (kind === "top_3_supporter") return <Medal className="w-3 h-3" />;
  return null;
}

/** Display the user's primary role + any top-supporter badges they hold. */
export default function RoleBadge({ role = "member", badges = [], size = "sm", showRole = true, className = "" }) {
  const tier = TIERS[role] || TIERS.member;
  const sizeCls = size === "xs" ? "text-[9px] px-1.5 py-0" : "text-[10px] px-2 py-0.5";

  // Founder is fully styled by .badge-founder class — bypass generic chip wrapper.
  const isFounder = role === "admin";
  const isGod = role === "god_tier_supporter";

  return (
    <span className={`inline-flex flex-wrap items-center gap-1 ${className}`}>
      {showRole && (
        <span
          className={
            isFounder
              ? `badge-founder ${size === "xs" ? "text-[9px]" : ""}`
              : isGod
              ? "badge-god"
              : `rounded uppercase tracking-wider font-bold ${tier.chip} inline-flex items-center gap-1 ${sizeCls}`
          }
          title={isFounder ? "Founder — Platform Owner" : tier.label}
        >
          {roleIcon(role)}
          <span>{tier.label}</span>
        </span>
      )}
      {(badges || []).map((b) => {
        const bd = BADGES[b];
        if (!bd) return null;
        return (
          <span key={b} className={`${bd.className} ${sizeCls}`} title={bd.label}>
            <TopBadgeIcon kind={b} /> {bd.short}
          </span>
        );
      })}
    </span>
  );
}
